import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "../";
import { ActionTypes } from ".";

import { IListItem, IRccapRootCause, ICenterBase, IContact } from "../../models";

export interface IRccapLookupDataResponse {
    data: {
        success: boolean,
        results: {
            phases: IListItem[],
            billable: IListItem[],
            avoidable: IListItem[],
            causes: IRccapRootCause[],
            correctiveActions: IListItem[],
            satisfactoryResponses: IListItem[],
            rccapStatusList: IListItem[],
            staffList: IContact[],
            centers: ICenterBase[]
        }
    }
}

export const ActionCreatorsRccapLookupData = {
    getRccapLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<IRccapLookupDataResponse> => {
        var options = {
            url: __API__ + "/rccap/lookup-data"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IRccapLookupDataResponse) => {
            var { success, results } = response.data;

            if (success) {
                var { phases, billable, avoidable, causes, correctiveActions, satisfactoryResponses } = results;

                dispatch(ActionCreatorsRccapLookupData.setRccapPhaseList(phases));
                dispatch(ActionCreatorsRccapLookupData.setRccapCauseList(causes));
                dispatch(ActionCreatorsRccapLookupData.setRccapAvoidableList(avoidable));
                dispatch(ActionCreatorsRccapLookupData.setRccapBillableList(billable));
                dispatch(ActionCreatorsRccapLookupData.setRccapCorrectiveActionList(correctiveActions));
                dispatch(ActionCreatorsRccapLookupData.setRccapSatisfactoryResponseList(satisfactoryResponses));
            }

            return Promise.resolve(response);
        });
    },
    setRccapPhaseList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_RCCAPPHASELIST,
            list
        };
    },
    setRccapBillableList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_RCCAPBILLABLELIST,
            list
        };
    },
    setRccapAvoidableList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_RCCAPAVOIDABLELIST,
            list
        };
    },
    setRccapCauseList: (list: IRccapRootCause[]) => {
        return {
            type: ActionTypes.SET_RCCAPCAUSELIST,
            list
        };
    },
    setRccapCorrectiveActionList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_RCCAPCORRECTIVEACTIONLIST,
            list
        };
    },
    setRccapSatisfactoryResponseList: (list: IListItem[]) => {
        return {
            type: ActionTypes.SET_RCCAPSATISFACTORYRESPONSELIST,
            list
        };
    }
};